<div class="backdrop" *ngIf="shouldShowUserInteractionOverlay$ | ngrxPush" @fade>
    <div class="prompt">
        <img
            class="prompt-image"
            [src]="{ light: 'assets/images/app-refresh-light.svg', dark: 'assets/images/app-refresh-dark.svg' } | themeVariant"
            alt=""
        />
        <span class="prompt-message">
            {{ "dtmUi.userInteractionOverlay.promptMessage" | transloco }}
        </span>
        <button class="button-primary" type="button">
            {{ "dtmUi.userInteractionOverlay.actionButtonLabel" | transloco }}
        </button>
    </div>
</div>
